import { useState } from "react";
import { Link } from "react-router-dom";
import { statusText } from "../UI/StatusText";
import SectionTitle from "../UI/SectionTitle";
import { MAIN } from "../../constants/styles";
import { ORDER_STATUSES } from "../../constants/profileData";
import { useGetOrders } from "../../hooks/useProducts";
import { dateFormatter, numberFormatter } from "../../helper/helpers";
import { statusBadge } from "../../constants/status_badges";

const SectionOrders = ({ user, onSelectOrder }) => {
  const [filter, setFilter] = useState("All");
  const [pageData, setPageData] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  // const customerId = useSelector(selectCustomerId);

  const {
    data = {},
    isPending,
    isError: ordersIsError,
    error: ordersError,
  } = useGetOrders({ ...pageData, id: user?.id });

  const orders = data?.orders?.data || [];
  let totalItemCount = data?.products?.count ?? 0;
  const totalPages = Math.ceil(totalItemCount / pageData.pageSize);

  const hasNextPage = () => {
    return pageData.pageIndex + 1 >= totalPages;
  };

  // Filter orders by selected status
  const visibleOrders =
    filter === "All"
      ? orders
      : orders.filter((o) => statusText(o.status) === filter);

  // Filter orders that have items
  // const ordersWithItems = visibleOrders.filter(
  //   (order) => order.items?.length > 0,
  // );

  // const statusBadge = (status) => {
  //   switch (status) {
  //     case "Delivered":
  //       return Badge.green(status);
  //     case "Pending":
  //       return Badge.main(status);
  //     case "Cancelled":
  //       return Badge.red(status);
  //     default:
  //       return Badge.blue(status);
  //   }
  // };

  if (isPending) return <p>Loading orders...</p>;
  if (ordersIsError) return <p>{ordersError}</p>;

  return (
    <div>
      <SectionTitle
        title="My Orders"
        subtitle="Track and manage your purchases"
      />

      {/* Status Filters */}
      <div className="d-flex gap-2 mb-24 flex-wrap">
        {ORDER_STATUSES.map((t) => (
          <button
            key={t}
            onClick={() => setFilter(t)}
            style={{
              padding: "7px 18px",
              borderRadius: 20,
              border: "1.5px solid",
              fontWeight: 600,
              fontSize: 13,
              cursor: "pointer",
              borderColor: filter === t ? MAIN : "#ddd",
              background: filter === t ? MAIN : "#fff",
              color: filter === t ? "#fff" : "#555",
            }}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Empty State if no orders with items */}
      {!visibleOrders.length && (
        <div
          className="container-fluid d-flex flex-column align-items-center justify-content-center text-center"
          style={{ minHeight: "50vh" }}
        >
          <img
            src={"/assets/images/illustrations/19.svg"}
            width={300}
            alt="No orders"
            className="img-fluid mb-16"
          />
          <h6 className="mb-16">You have no orders yet</h6>
          <Link
            to="/"
            className="link text-line-2 bg-main-50 hover-bg-main-100 transition-2 text-black rounded-5 py-10 px-20 d-inline-flex align-items-center gap-8"
          >
            <i className="ph ph-shopping-cart" /> Shop today's deals
          </Link>
        </div>
      )}

      {/* Orders List */}
      {visibleOrders.length > 0 &&
        visibleOrders.map((order) => {
          const orderStatusText = statusText(order.status);
          return (
            <div
              key={order.id}
              className="border rounded p-13 mb-3 position-relative"
              style={{ background: "#fff" }}
            >
              <Link
                onClick={() => onSelectOrder(order.id)}
                style={{
                  position: "absolute",
                  top: 12,
                  right: 16,
                  fontSize: 13,
                  color: MAIN,
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                See More Details
              </Link>

              <div className="d-flex gap-3 align-items-start">
                {/* Product Image */}

                <span className="table-product__content text-start">
                  <div style={{ marginBottom: 8 }}>
                    {statusBadge(orderStatusText)}
                    {/* {statusBadge(orderStatusText)} */}
                  </div>
                  <span
                    // to={`/order/detail/${order.id}`}
                    className="text-dark hover-text-main-600 fw-semibold w-100 title mb-5"
                  >
                    Order:- {"  "}
                    {order?.orderNumber}
                  </span>
                  <div className="vstack my-5 gap-6">
                    <span className="py-2 text-xs">
                      Items: {"  "}
                      {order?.itemsCount}
                    </span>
                    <span className="text-sm mt-5 mb-0 fw-semibold">
                      On{" "}
                      {order?.createdAt &&
                        dateFormatter.format(new Date(order?.createdAt))}
                    </span>
                    <span className="text-sm mt-5 mb-0 fw-semibold">
                      Total: {numberFormatter.format(Number(order?.itemsCount))}
                    </span>
                  </div>
                </span>

                {/* Product Info */}
                {/* <div style={{ flex: 1 }}>
                  <p style={{ fontWeight: 600, marginBottom: 4 }}>
                    {order.items.map((item) => item.productName).join(", ")}
                  </p>
                  <p style={{ fontSize: 13, color: "#777", marginBottom: 6 }}>
                    KES {order.totalPrice} ·{" "}
                    {new Date(order.createdAt).toLocaleDateString()}
                  </p>
                  <div style={{ marginBottom: 8 }}>
                    {statusBadge(orderStatusText)}
                  </div>
                </div> */}
              </div>
            </div>
          );
        })}
      <div className="d-flex justify-content-start mt-30">
        <div className="hstack gap-5">
          <button
            className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100 hover-bg-main-600 hover-text-white transition-1"
            disabled={pageData.pageIndex === 0}
            onClick={() =>
              setPageData((prevData) => ({
                ...prevData,
                pageIndex: prevData.pageIndex - 1,
              }))
            }
          >
            <i className="ph-bold ph-arrow-left" />
          </button>
          <button
            className={`btn btn-sm page-link h-40 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100 page-item active`}
            disabled
          >
            {(pageData.pageIndex + 1).toString().padStart(2, "0")}
          </button>
          <button
            className="btn btn-sm page-link h-20 w-44 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100 hover-bg-main-600 hover-text-white transition-1"
            disabled={hasNextPage()}
            onClick={() =>
              setPageData((prevData) => ({
                ...prevData,
                pageIndex: prevData.pageIndex + 1,
              }))
            }
          >
            <i className="ph-bold ph-arrow-right" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SectionOrders;
